import { useRouteParams, useRouteQuery } from "@vueuse/router";

export function usePageParams<T>(name: string, type: "path" | "query") {
  const paramName = ref(name);
  const paramType = ref<"path" | "query">(type);

  const route = useRoute();

  const paramRef = type === "path" ? useRouteParams(name) : useRouteQuery(name);

  const param = computed<T>(() => {
    if (paramType.value === "path") {
      return (paramRef.value || route.params[paramName.value]) as T;
    }

    return (paramRef.value || route.query[paramName.value]) as T;
  });

  const routeQuery = () => route.query;

  return {
    param,
    paramRef,
    paramName,
    paramType,
    routeQuery,
  };
}
